import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { HBox, VBox } from '../../../components/Box';
import { Cell, List, Row } from '../../../components/List';
import { formatCurrency, formatCurrencyValue } from '../../../utils/string';
import { IsOpen } from '../../../components/Icon';
import { selectConfig, selectWorks } from '../../Api/selectors';
import { initiateVehicleEdit, setNewVehicleValue, setVehicleProperties } from '../actions';
import {
  REQUEST_VEHICLE,
  REQUEST_VEHICLE_PROPERTIES,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  VEHICLE_DETAILS_SALESCARD,
} from '../constants';

import { selectNewVehicle } from '../selectors';

import { VehicleCardSalesField } from './CardSalesFields/Fields';
import { SALES_DATA_CRUD, SALES_PRICES_CRUD } from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { WIENTJES_INSTALATION } from '../../../containers/App/constants';
import cn from 'classnames';
import styles from './CardFinanceSalesPropertyList.module.css';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import { OnMouseOverNotification } from './OnMouseOverNotification';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';

const Container = styled.div`
  font-size: 14px;

  .card-header {
    margin-bottom: 20px;
  }
  .card-title {
    white-space: nowrap;
  }

  .button-block {
    width: 50%;
  }

  .cell:first-child {
    text-transform: capitalize;
  }

  .info-cell:hover {
    cursor: pointer;
  }

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }

  .icon-edit-square {
    color: #d9d9d9;
  }

  .dropdown-wrapper {
    .dropdown-card {
      height: 35px;
    }
  }
`;

const STATE = {
  isEditVehicle: false,
  values: null,
};
/* eslint-disable react/prefer-stateless-function */
class VehicleFinanceSalesPropertyListComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  save() {
    this.props.onSave();
  }

  reset() {
    this.props.reset();
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get salesDataProps() {
    return [
      'sell_with_license_plate',
      'sell_without_license_plate',
      'fix_damages',
      'dont_fix_damages',
      'fix_damages_details',
    ];
  }

  get salesPricesProps() {
    return [
      'HILT_appraise_sum',
      'HILT_bid_sum',
      'financial_price_b2c',
      'financial_price_b2b_incl_vat_btpm',
      'financial_price_gross_incl_btw_bpm',
      'financial_price_nett_excl_vat_bpm',
      'outgoing_rest_bpm',
      'catalogprice_incl_options',
      // 'delivery_costs',
    ];
  }

  get isDisabledOutgRestBpm() {
    let isDisabled = true;

    if (this.vehicle?.taxiVerleden === '1' && this.props.isEdit) {
      isDisabled = false;
    }

    return isDisabled;
  }

  checkbox(type) {
    let disabled = false;
    if (type === 'import') disabled = this.isImportDisabled();
    return (
      <CheckboxComponent
        onChange={() => {
          if (!this.state.isEditVehicle) return;
          this.state[type] == '1' ? this.setState({ [type]: '0' }) : this.setState({ [type]: '1' });
        }}
        checked={this.state[type] == '1'}
        disabled={disabled}
      />
    );
  }

  wrapFieldIntoPermissionsComp(property, component) {
    let permission = null;
    if (this.salesDataProps.includes(property)) permission = SALES_DATA_CRUD;
    if (this.salesPricesProps.includes(property)) permission = SALES_PRICES_CRUD;
    if (env.clientId == AppClientId.AUTOWIENTJES) return component;
    return <Permission permission={permission}>{component}</Permission>;
  }
  render() {
    const vehicle = this.props.values;
    if (this.props.work) return <Loader small />;

    return (
      <Container>
        {(this.props.isOpen || window.innerWidth > 768) && (
          <>
            {VEHICLE_DETAILS_SALESCARD.map(property => {
              if (vehicle?.is_imported !== '1' && property === 'rest_bpm_export') return;

              if (vehicle?.is_imported == '1' && property === 'outgoing_rest_bpm') return;

              if (this.props.serverConfig.disableBPM && property === 'outgoing_rest_bpm') return '';
              if (
                this.props.isShowPropertyCell(property) &&
                
                (
                  property == 'HILT_appraise_sum' ||
                  property == 'HILT_bid_sum' ||
                  property == 'financial_price_b2c' ||
                  property == 'financial_price_b2b_incl_vat_btpm' ||
                  property == 'financial_price_gross_incl_btw_bpm' ||
                  property == 'financial_price_nett_excl_vat_bpm' ||
                  property == 'outgoing_rest_bpm' ||
                  property == 'catalogprice_incl_options' ||
                  property == 'rest_bpm_export')
                // property == 'delivery_costs'
              ) {
                return (
                  <div key={`${property}-container`}>
                    {this.wrapFieldIntoPermissionsComp(
                      property,

                      <div className={styles.containerLabel}>
                        {this.props.isEdit ? (
                          <>
                            {env.clientId == AppClientId.AUTOWIENTJES &&
                            (property === 'financial_price_gross_incl_btw_bpm' ||
                              property === 'financial_price_nett_excl_vat_bpm') ? (
                              <label className={cn('form-label', styles.label)}>
                                {this.lbl(`vehicle.property.${property}_wientjes`)}
                              </label>
                            ) : (
                              <label className={cn('form-label', styles.label)}>
                                {this.lbl(`vehicle.property.${property}`)}
                              </label>
                            )}

                            <VehicleCardSalesField
                              key={property}
                              type={property}
                              vehicle={vehicle}
                              isDisabledOutgRestBpm={this.isDisabledOutgRestBpm}
                            />
                          </>
                        ) : (
                          <div className={styles.formField}>
                            {env.clientId == AppClientId.AUTOWIENTJES &&
                            (property === 'financial_price_gross_incl_btw_bpm' ||
                              property === 'financial_price_nett_excl_vat_bpm') ? (
                              <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}_wientjes`)}</div>
                            ) : (
                              <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                            )}

                            <div className={styles.labelTable}>
                              <HBox left vCenter>
                                {env.clientId == AppClientId.AUTOWIENTJES &&
                                property == 'rest_bpm_export' &&
                                !vehicle[property]
                                  ? '€ 0.00'
                                  : formatCurrencyValue(vehicle[property])}
                                {vehicle?.taxiVerleden === '1' && property === 'outgoing_rest_bpm' && (
                                  <OnMouseOverNotification message={this.lbl('alert.is_taxi_tax_message')} />
                                )}
                                {property === 'rest_bpm_export' && (
                                  <OnMouseOverNotification message={this.lbl('alert.rest_bpm_export_tax_message')} />
                                )}
                              </HBox>
                            </div>
                          </div>
                        )}
                      </div>,
                    )}
                  </div>
                );
              }

              if (
                property === 'sell_with_license_plate' ||
                property === 'sell_without_license_plate' ||
                property === 'fix_damages' ||
                property === 'dont_fix_damages'
              ) {
                return this.wrapFieldIntoPermissionsComp(
                  property,
                  <div key={`${property}-container`}>
                    {this.props.isEdit ? (
                      <div className={styles.checkboxContainer}>
                        <VehicleCardSalesField key={property} type={property} isEdit={this.props.isEdit} />
                        <label className={cn('form-label', styles.label)}>{this.lbl(`vehicle.property.${property}`)}</label>
                      </div>
                    ) : (
                      <div className={styles.formField}>
                        <label className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</label>
                        <VehicleCardSalesField key={property} type={property} isEdit={this.props.isEdit} />
                      </div>
                    )}
                  </div>,
                );
              }

              if (property === 'tax_type') {
                return (
                  this.props.isShowPropertyCell(property) &&
                  this.wrapFieldIntoPermissionsComp(
                    property,
                    <div key={`${property}-container`}>
                      <div className={styles.formField}>
                        <label className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</label>

                        <VehicleCardSalesField key={property} type={property} isEdit={this.props.isEdit} />
                      </div>

                      <div className={styles.containerLabel}>
                        {this.props.isEdit && <b style={{ margin: 0 }}>{this.lbl('vehicle.property.tax_type.warning')}</b>}
                      </div>
                    </div>,
                  )
                );
              }

              if (property === 'sales_preferred_vehicle' || property === 'vehicle_purpose') {
                return (
                  this.props.isShowPropertyCell(property) &&
                  this.wrapFieldIntoPermissionsComp(
                    property,
                    <div className={styles.containerLabel} key={`${property}-container`}>
                      {this.props.isEdit ? (
                        <>
                          <label className={cn('form-label', styles.label)}>
                            {this.lbl(`vehicle.property.${property}`)}
                          </label>

                          <VehicleCardSalesField key={property} type={property} />
                        </>
                      ) : (
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                            {this.lbl(`vehicle.property.${property}.${vehicle[property]}`)}
                          </div>
                        </div>
                      )}
                    </div>,
                  )
                );
              }

              return (
                this.props.isShowPropertyCell(property) &&
                this.wrapFieldIntoPermissionsComp(
                  property,
                  <div className={styles.containerLabel} key={`${property}-container`}>
                    {this.props.isEdit ? (
                      <>
                        <label className={cn('form-label', styles.label)}>{this.lbl(`vehicle.property.${property}`)}</label>
                        <VehicleCardSalesField key={property} type={property} />
                      </>
                    ) : (
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`vehicle.property.${property}`)}</div>
                        <div className={styles.labelTable}>
                          {property === 'fix_damages_details'
                            ? vehicle[property]
                            : this.lbl(`vehicle.property.${property}.${vehicle[property]}`)}
                        </div>
                      </div>
                    )}
                  </div>,
                )
              );
            })}
          </>
        )}
      </Container>
    );
  }
}

VehicleFinanceSalesPropertyListComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_VEHICLE,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      `${REQUEST_VEHICLE_PROPERTIES}-${ownProps.vehicle?.id}`,
    ]),
    values: selectNewVehicle(),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    patch(props, callback) {
      dispatch(setVehicleProperties(ownProps.vehicle?.id, props, callback));
    },
    init() {
      dispatch(initiateVehicleEdit(ownProps.vehicle?.id));
    },
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewVehicleValue(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleFinanceSalesPropertyList = compose(withConnect, withRouter)(VehicleFinanceSalesPropertyListComp);
